import { AppBar, Toolbar, Typography, Box } from '@mui/material'
import { Stack, styled } from '@mui/system'
import React, { useContext } from 'react'
import { AuthContext } from "../authContext/AuthContext";
import { logout } from "../authContext/AuthActions";
import { Link, useHistory } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between"
});

const Navbar = ({ height }) => {
  const { user, shop, dispatch } = useContext(AuthContext);
  const history = useHistory();
  
  const currentEnv = process.env.REACT_APP_ENVIRONMENT || 'development';
  const isProduction = currentEnv === 'production';

  return (
    <AppBar position="sticky" sx={{ height: height }} >
      <StyledToolbar>
        {user && (
          <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
            <Box
              component="img"
              src="/favicon.svg"
              alt="Home"
              sx={{
                height: 42,
                width: 42,
                filter: 'drop-shadow(0px 3px 5px rgba(0, 0, 0, 0.4))',
                transition: 'all 0.3s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.1)',
                  filter: 'drop-shadow(0px 5px 8px rgba(0, 0, 0, 0.6))',
                },
              }}
            />
          </Link>
        )}
        
        <Box display="flex" alignItems="center" gap={1}>
          <Typography variant="h6">Sri Kumaran Sweets</Typography>
          {!isProduction && (
            <Box
              sx={{
                backgroundColor: 'warning.main',
                color: 'warning.contrastText',
                px: 1,
                py: 0.25,
                borderRadius: 1,
                fontSize: '0.7rem',
                fontWeight: 'bold',
              }}
            >
              {currentEnv.toUpperCase()}
            </Box>
          )}
        </Box>

        <Stack direction="row" spacing={2} alignItems="center">
          {user && (
            <Box display="flex" flexDirection="column" alignItems="center">
              <Typography variant="h6" sx={{ lineHeight: 1 }}>{user.name}</Typography>
              {user.isAdmin && (
                <Typography 
                  variant="caption" 
                  onClick={() => history.push('/settings')} 
                  sx={{ color: 'white', textDecoration: 'underline', cursor: 'pointer', mt: 0.5 }}
                >
                  Settings
                </Typography>
              )}
            </Box>
          )}
          {shop && <Typography variant="h6">({shop.shopkey})</Typography>}
          {user && <LogoutIcon style={{ color: '#FFF', fontSize: 40, cursor: 'pointer' }} onClick={() => dispatch(logout())}/>} 
        </Stack>
      </StyledToolbar>
    </AppBar>
  )
}

export default Navbar